import React from 'react'
import { InformationPopover } from '../../../common/popover/InformationPopover'
import { DemandAnalysisQuestionCriteria } from '../DemandAnalysisQuestionCriteria'
import { makeStyles } from '@fluentui/react-components'
import { ClipboardTextLtr20Regular, ClipboardTextLtr20Filled } from '@fluentui/react-icons'
import { t } from '../../../../i18n/i18n'
import { DemandAnalysisQuestion } from '../../../../api/schemas/schema'

const useStyles = makeStyles({
   hideInPhone: {
      '@media screen and (max-width: 640px)': {
         display: 'none',
      },
   },
   showInPhone: {
      '@media screen and (min-width: 640px)': {
         display: 'none',
      },
   },
   popoverPhone: {
      height: '50vh',
      overflowY: 'hidden',
   },
   popoverDesktop: {
      top: '16px !important',
   },   
})

export const DemandAnalysisQuestionPopovers = (item: DemandAnalysisQuestion) => {
   const classes = useStyles()

   return (
      <>
         <div className={classes.hideInPhone}>
            <InformationPopover
               btnLabel={t('Criteria')}
               popoverLabel={t('Criteria')}
               input={<DemandAnalysisQuestionCriteria answerOptions={item?.answerOptions} />}
               regularIcon={<ClipboardTextLtr20Regular />}
               filledIcon={<ClipboardTextLtr20Filled />}
               position={{ position: 'after', align: 'center' }}
               className={classes.popoverDesktop}
            />
         </div>
         <div className={classes.showInPhone}>
            <InformationPopover
               btnLabel={t('Criteria')}
               popoverLabel={t('Criteria')}
               input={<DemandAnalysisQuestionCriteria answerOptions={item?.answerOptions} />}
               regularIcon={<ClipboardTextLtr20Regular />}
               filledIcon={<ClipboardTextLtr20Filled />}
               className={classes.popoverPhone}
            />
         </div>
      </>
   )
}
